import {CREATECASE_FAILED, CREATECASE_SUCCESS, FILESUPLOADED, GETFILELINK, UPLOADFILE} from '../constants'
import axiosInstance from "../utils/axios.interceptor";
import axios from "axios";
import {saveAs} from "file-saver";
/***
 * getLinkForUpload
 */
export const getLinkForUpload = (usertype) => {
  return async (dispatch) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/getLinkForUpload',
      data: {"hashValue": usertype}
    });
    //This is to trigger componentWillReceiveProps()
    response.data.timestamp = new Date().toLocaleString();
    dispatch({type:UPLOADFILE,payload:response.data});
  };
};

/**
 * getMultipleLinksForUpload -- returns an Array of upload URLs to S3.
 *
 * EXAMPLE BODY:-
 * {
    "hashValue":"8r398r5938248349ctu3489t",
    "files":[
        {"filename":"test.pdf","extension":"application/pdf"},
        {"filename":"hello.jpeg","extension":"image/jpeg"}
    ]
 * }
 */
export const getMultipleLinksForUpload = (hashValue,files) => {
  return async (dispatch) => {
    let newBuffer = [];
    files.map(item=>{
      newBuffer.push({"filename":item.file.name,"extension":item.file.type});
    })
    let requestBody = {};
    requestBody.hashValue = hashValue;
    requestBody.files = newBuffer;
    let response = await axiosInstance({
      method: 'POST',
      url: '/getMultipleLinksForUpload',
      data: requestBody
    });

    dispatch({type:UPLOADFILE,payload:response.data});
  };
};


/**
 * uploadFileToDrive -- Single File Upload to S3
 */
export const uploadFileToDrive = (uploadData, file) => {
  return async (dispatch) => {
    try {
      let formData = new FormData();
      Object.keys(uploadData.fields).forEach(key => {
        formData.append(key, uploadData.fields[key]);
      });

      formData.append('file', file);
      // Display the key/value pairs
      for (var pair of formData.entries()) {
        console.log(pair[0]+ ', ' + pair[1]);
      }

      let response = await axios({
        method: 'POST',
        baseURL: '',
        url: uploadData.url,
        data: formData,
        headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data' }
      })

      if (response.status !== 204) {
        console.log('Failed to upload to S3 bucket');

      }
      else {
        console.log("File uploaded");
        dispatch({type:UPLOADFILE,payload:{}});
      }
    }
    catch (error) {
      console.log('uploadFileToDrive err', error)
      dispatch({type:UPLOADFILE,payload: {}});
    }
  }
}

const uploadSingleFile = async (uploadData, file) => {
  let formData = new FormData();
  Object.keys(uploadData.fields).forEach(key => {
    formData.append(key, uploadData.fields[key]);
  });
  formData.append('file', file);
  let response = await axios({
    method: 'POST',
    baseURL: '',
    url: uploadData.url,
    data: formData,
    headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data'}
  })
}

/**
 * Uploads Multiple Files to S3
 */
export const uploadMultipleFilesToDrive = (presignedDataList, files) => {
  return async (dispatch) => {
    let newFileBuffer = [];
    presignedDataList.map((fileItem,index)=>{
      let tempBuffer = {};
      tempBuffer.uploadData = presignedDataList[index];
      tempBuffer.fileobject = files[index];
      newFileBuffer.push(tempBuffer)
    });
    console.log(newFileBuffer)
    await Promise.all(newFileBuffer.map(item => uploadSingleFile(item.uploadData,item.fileobject.file)));
    dispatch({type:UPLOADFILE,payload: {}});
  }
}

/**
 * Generates presigned POST URLS for S3 and uplaods required files to S3
 *
 * Also adds references to tblattachments.
 *
 * @returns -- file path(s) on S3 where documents are saved.
 */
export const automatedMultipleFilesUpload = (hashValue,files,billtype,policyholderid) => {
  return async (dispatch) => {
    //Requests POST URLS from S3
    let newBuffer = [];
    let tblattachmentsBuffer = [];
    files.map(item=>{
      newBuffer.push({"filename":item.file.name,"extension":item.file.type});
    })
    let requestBody = {};
    requestBody.hashValue = hashValue;
    requestBody.files = newBuffer;
    let fileLinks = await axiosInstance({
      method: 'POST',
      url: '/getMultipleLinksForUpload',
      data: requestBody
    });
    let presignedDataList = Object.values(fileLinks.data);

    //Uploads files to S3
    let newFileBuffer = [];
    presignedDataList.map((fileItem,index)=>{
      let tempBuffer = {};
      tempBuffer.uploadData = presignedDataList[index];
      tempBuffer.fileobject = files[index];
      newFileBuffer.push(tempBuffer)
    });
    await Promise.all(newFileBuffer.map(item => uploadSingleFile(item.uploadData,item.fileobject.file)));

    //Add references to db
    presignedDataList.map((tblitem,index)=>{
      tblattachmentsBuffer.push({
        attachmentuuid:tblitem.fields.key,
        filename:tblitem.filename,
        dateuploaded:new Date().toLocaleString(),
        billtype:billtype,
        policyholderid:policyholderid
      })
    });
    console.log('tblattachmentsBuffer',tblattachmentsBuffer);
    let attachments_references = await axiosInstance({
      method: 'POST',
      url: '/saveattachmentreferences',
      data: {"attachments":tblattachmentsBuffer}
    });
    //On completion dispatch to inform front-end
    dispatch({type:FILESUPLOADED,payload:Object.values(fileLinks.data)});
  };
};

const automatedMultipleFilesUploadFunction = async (hashValue,files,billtype,policyholderid,commonid) => {
  //Requests POST URLS from S3
  let newBuffer = [];
  let tblattachmentsBuffer = [];
  files.map(item=>{
    newBuffer.push({"filename":item.file.name,"extension":item.file.type});
  })
  let requestBody = {};
  requestBody.hashValue = hashValue;
  requestBody.files = newBuffer;
  let fileLinks = await axiosInstance({
    method: 'POST',
    url: '/getMultipleLinksForUpload',
    data: requestBody
  });
  let presignedDataList = Object.values(fileLinks.data);

  //Uploads files to S3
  let newFileBuffer = [];
  presignedDataList.map((fileItem,index)=>{
    let tempBuffer = {};
    tempBuffer.uploadData = presignedDataList[index];
    tempBuffer.fileobject = files[index];
    newFileBuffer.push(tempBuffer)
  });
  await Promise.all(newFileBuffer.map(item => uploadSingleFile(item.uploadData,item.fileobject.file)));

  //Add references to db
  presignedDataList.map((tblitem,index)=>{
    tblattachmentsBuffer.push({
      attachmentuuid:tblitem.fields.key,
      filename:tblitem.filename,
      dateuploaded:new Date().toLocaleString(),
      billtype:billtype,
      policyholderid:policyholderid,
      hashValue:hashValue,
      commonid:commonid
    })
  });
  console.log('tblattachmentsBuffer',tblattachmentsBuffer);
  let attachments_references = await axiosInstance({
    method: 'POST',
    url: '/saveattachmentreferences',
    data: {"attachments":tblattachmentsBuffer}
  });
}

export const automatedSingleFileUpload = (fileitem,userdata) => {
  return async (dispatch) => {
    const {login,agency,company} = userdata;
    let response = await axiosInstance({
      method: 'POST',
      url: '/getLinkForUpload',
      data: {"hashValue": fileitem.file.name,"filename": fileitem.file.name,"extension":'application/pdf'}
    });
    let requestBody = await uploadSingleFile(response.data,fileitem.file);
    let responseTBL = await axiosInstance({
      method: 'POST',
      url: '/adduploadreference',
      data: {"hashValue":response.data.fields.key,filename: fileitem.file.name,"extension":'application/pdf',status:'PENDING',login:login,agency:agency,company:company}
    });
    response.timestamp = new Date().toLocaleString();
    dispatch({type: FILESUPLOADED, payload: response});
  }
}

/**
 * Automatically downloads file from specified filepath and filename
 */
export const downloadDocument = (filepath,filename) =>{
  return async (dispatch) => {
    let downloadable_file = await axiosInstance({
      method: 'POST',
      url: '/getDownloadLink',
      data: {"filepath":filepath,"filename":filename}
    });
    fetch(downloadable_file.data.link, {
      method: 'GET',
    })
      .then(function (response) {
          return response.blob();
        }
      )
      .then(function(blob) {
        saveAs(blob,filename);
      })
      .catch(error => {
      })
  }
}

/**
 * Get attachments list by caseid
 */
export const findAttachmentsByhashValue = (caseid) =>{
  return async (dispatch) => {
    let downloadable_files= await axiosInstance({
      method: 'POST',
      url: '/findAttachmentsByhashValue',
      data: {"caseid":caseid}
    });
    dispatch({type:GETFILELINK,payload:downloadable_files})
  }
}

/**
 * Get the link to the test file from S3
 * @returns PDF URL
 */
export const getTestFile = () =>{
  return async (dispatch) => {
    let file_item = await axiosInstance({
      method: 'POST',
      url: '/getTestFile',
      data: {}
    });
    dispatch({type:GETFILELINK,payload:file_item})
  }
}

